import { Translation } from "react-i18next"
import { ExamPeriodMonitorState, Report } from "@types"
import { Typography } from "antd"
import dayjs from 'dayjs';


export const examPeriodStateFormat = (value: ExamPeriodMonitorState) => {
    switch (value) {
        case ExamPeriodMonitorState.WaitingForParticipant:
            return <Translation> 
            {
                t => <Typography.Text strong type="warning">{t("pages.examPeriods.waitingForParticipant")}</Typography.Text>
            }
            </Translation>
        case ExamPeriodMonitorState.NoShow:
            return <Translation> 
            {
                t => <Typography.Text strong type="danger">{t("pages.examPeriods.notShowed")}</Typography.Text>
            }
            </Translation>
        case ExamPeriodMonitorState.InProgress:
            return <Translation> 
            {
                t => <Typography.Text strong type="success">{t("pages.examPeriods.inProgress")}</Typography.Text>
            }
            </Translation>
        case ExamPeriodMonitorState.Completed:
            return <Translation> 
            {
                t => <Typography.Text strong type="success">{t("pages.examPeriods.completed")}</Typography.Text>
            }
            </Translation>
        case ExamPeriodMonitorState.Excluded:
            return <Translation> 
            {
                t => <Typography.Text strong type="danger">{t("pages.examPeriods.disqualified")}</Typography.Text>
            }
            </Translation>
        case ExamPeriodMonitorState.Paused:
            return <Translation> 
            {
                t => <Typography.Text strong type="warning">{t("pages.examPeriods.paused")}</Typography.Text>
            }
            </Translation>
        case ExamPeriodMonitorState.ParticipantConfirmed:
            return <Translation> 
            {
                t => <Typography.Text strong type="success">{t("pages.examPeriods.participantConfirmed")}</Typography.Text>
            }
            </Translation>
        default:
            return "";
    }
}

/**
 * Pretvara danjs.Dayjs objekt u ukupne sekunde.
 *
 * @param {dayjs.Dayjs | number} time - Dayjs objekt koji predstavlja vrijeme, ili broj sekundi.
 * @returns {number} Ukupan broj sekundi koji odgovara satima i minutama u danom Dayjs objektu.
 */
export const convertDayjsToTotalSeconds = (time: dayjs.Dayjs | number): number => {
    if (typeof time === 'number') {
        return time;
    }

    if (!time || !dayjs.isDayjs(time)) {
        return 0;
    }

    const hours = time.hour();
    const minutes = time.minute();

    // Pretvori sate i minute u ukupne sekunde (1 sat = 3600 sekundi, 1 minuta = 60 sekundi)
    return (hours * 3600) + (minutes * 60);
}


export const examPeriodHasPassedFormat = (record: Report) => {

    if (record.examInstanceState === ExamPeriodMonitorState.Completed || record.examInstanceState === ExamPeriodMonitorState.Excluded) {
        return record.hasPassed ? <Translation> 
        {
            t => <Typography.Text strong type="success">{t("table.passed")}</Typography.Text>
        }
        </Translation> : <Translation> 
        {
            t => <Typography.Text strong type="danger">{t("table.failed")}</Typography.Text>
        }
        </Translation>
    } else {
        return examPeriodStateFormat(record.examInstanceState);
    }

}
